import { render, staticRenderFns } from "./VoteChartDonut.vue?vue&type=template&id=83df1692"
import script from "./VoteChartDonut.vue?vue&type=script&lang=js"
export * from "./VoteChartDonut.vue?vue&type=script&lang=js"
import style0 from "./VoteChartDonut.vue?vue&type=style&index=0&id=83df1692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports